var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.462,
    height: 12.462,
    viewBox: "0 0 12.462 12.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.459 -685.176) rotate(135)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1346.145 368.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.929,
    height: 1.386,
    rx: 0.693,
    transform: "translate(4.9 5.879) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.929,
    height: 1.386,
    rx: 0.693,
    transform: "translate(5.879 4.93) rotate(135)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1350.02 368.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.929,
    height: 1.386,
    rx: 0.693,
    transform: "translate(0 4.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.929,
    height: 1.386,
    rx: 0.693,
    transform: "translate(0.98 3.95) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0c7838cc71f6327811d68407a9043476.svg";
export { ForwardRef as ReactComponent };